module.exports = __webpack_public_path__ + "static/blackrock-logo-symbol-9ff541e3c67224fd49e580c47a158f93.svg";